<template>
  <ul>
    <li v-for="entry in entries" :key="entry.id">
      <span
        tabindex="0"
        class="result-template-thumbnail"
        @click="openModal(entry)"
        @keyup.enter="openModal(entry)"
      >
        <figure>
          <img
            :src="entry.image_src || entry.image"
            sizes="(max-width: 34em) 85, (max-width: 46.875em) 39, (max-width: 95.625em) 19, 292px"
            :srcset="entry.srcset"
            :alt="entry.title"
          >
        </figure>
        <h5>{{ entry.title }}</h5>
      </span>
    </li>
  </ul>
</template>

<script>
import EventBus from '../event_bus';

export default {
  props: ["inspirations"],
  data: function() {
    return {
      isLoading: true,
      currentEntries: [],
    };
  },
  computed: {
    collectionIds: function() {
      return this.currentEntries.map(x => parseInt(x.id));
    },
    entries: function() {
      return JSON.parse(this.inspirations);
    },
  },
  methods: {
    openModal: function(entry) {
      this.setEntriesWithinBounds(entry);
      EventBus.$emit('open-modal', entry.id, this.collectionIds, 'carousel');
    },
    closeLoading: function() {
      this.isLoading = false;
    },
    cancelModal: function() {
      this.closeLoading();
      this.$emit("close-modal");
      this.showNotification("There was an issue loading the item");
    },
     setEntriesWithinBounds: function(entry) {
      const idx = this.entries.indexOf(entry);
      const distanceFromEnd = this.entries.length - idx;
      let selectedEntries = [];
      let start = -6;
      let end = 6;

      if (distanceFromEnd < 6) {
        start = (-12 + distanceFromEnd);
        end = (12 + start);

        for (let i=start; i<end; i++) {
          selectedEntries.push(this.entries[idx + i]);
        }
      } else if (idx < 7) {
        selectedEntries = this.entries.slice(0, 12);
      } else {
         for (let i=start; i<end; i++) {
           selectedEntries.push(this.entries[idx + i]);
         }
      }

      this.currentEntries = selectedEntries.filter(entry => entry);
    },
  },
};
</script>
